import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Text from 'particles/Text'

import {
    clearMassSubmissionUuids,
    REVIEW_MODAL_TYPE,
    selectConfirmRejectDataInWaitingList,
    selectReviewModalFilterOptions,
    selectReviewModalPageNum,
    selectReviewModalType,
    setActivePageNum,
    setPartiposterTagFilter,
    setReviewModalOpen,
    setVoteTypeFilter,
    setResubmittedTypeFilter,
} from 'state/review'
import { rejectSubmission } from 'state/submissions'
import Modal from 'particles/Modal'

interface MultiSelectOffProps {
    title: string
    description: string
    detail?: string
    confirmText?: string
    hasIcon?: boolean
    isClosable?: boolean
    size?: 's' | 'm' | 'l'
}

const MultiSelectOff: React.FC<MultiSelectOffProps> = ({
    title,
    description,
    detail,
    confirmText,
    hasIcon,
    isClosable,
    size = 'm',
}) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const modalType = useSelector(selectReviewModalType)
    const modalFilterOptions = useSelector(selectReviewModalFilterOptions)
    const modalPageNum = useSelector(selectReviewModalPageNum)
    const rejectData = useSelector(selectConfirmRejectDataInWaitingList)

    const setModalOpen = (isOpen: boolean) => {
        dispatch(setReviewModalOpen(isOpen))
    }

    const handleChange = () => {
        switch (modalType) {
            case REVIEW_MODAL_TYPE.FILTER:
                dispatch(setVoteTypeFilter(modalFilterOptions.voteTypeFilter))
                dispatch(setPartiposterTagFilter(modalFilterOptions.partiposterTagFilter))
                dispatch(setResubmittedTypeFilter(modalFilterOptions.resubmittedTypeFilter))
                dispatch(clearMassSubmissionUuids())
                break
            case REVIEW_MODAL_TYPE.LEAVE:
                dispatch(setActivePageNum(modalPageNum))
                dispatch(clearMassSubmissionUuids())
                break
            case REVIEW_MODAL_TYPE.REJECT_SUBMISSION_IN_WAITING_LIST:
                dispatch(rejectSubmission(rejectData))
                break
            default:
                break
        }
        setModalOpen(false)
    }

    return (
        <Modal
            title={title}
            subtext={description}
            size={size}
            hasIcon={hasIcon}
            isClosable={isClosable}
            primaryButtonProps={{ label: confirmText || t('button.turnOff') }}
            secondaryButtonProps={{ label: t('button.cancel') }}
            onConfirm={handleChange}
            onClose={() => setModalOpen(false)}
        >
            {detail && <Text scale="bodyM400">{detail}</Text>}
        </Modal>
    )
}

export default MultiSelectOff
